document.addEventListener('click', async function (e) {
    const btnModalEliminarArea = e.target.closest('#btnModalEliminarArea');
    if (!btnModalEliminarArea) return;

    const idArea = btnModalEliminarArea.getAttribute("data-id");
    const formEliminar = document.querySelector("#formEliminarArea");
    const modalEliminar = document.querySelector("#ModalEliminarArea");

    if (!idArea || !formEliminar || !modalEliminar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para eliminar el área.", "alerta-roja");
        }
        return;
    }
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const url = `/api/configuracion/areas/infoArea?idArea=${idArea}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del usuario.", "alerta-roja");
            }
            setTimeout(() => {
                window.location.reload();
            }, 1500);
            return;
        }

        modalEliminar.classList.add('modal--show');
        const inputIdArea = formEliminar.querySelector('#idAreaEliminar');
        const strongNombreArea = modalEliminar.querySelector('#nombreEliminarArea');

        if (inputIdArea) inputIdArea.value = data.idArea || "";
        if (strongNombreArea) strongNombreArea.textContent = data.nombreArea || "";

    } catch (error) {
        console.error("Error al obtener información del usuario:", error);

        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del usuario.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEliminarArea') {
        e.preventDefault();
        const formulario = e.target;
        const modalEliminar = document.querySelector("#ModalEliminarArea");
        const btnSubmit = formulario.querySelector('#btnEliminarArea');
        const spinner = formulario.querySelector('#spinner');
        const formData = new FormData(formulario);
        if (!formulario || !modalEliminar || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para eliminar la área.", "alerta-roja");
            }
            return;
        }    
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/areas/eliminar', {
                method: 'POST',
                body: formData
            });
            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
                modalEliminar.classList.remove('modal--show');
            } 
            if (!resultado.hayErrores) {
                lanzarAlerta("Área eliminada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            modalEliminar.classList.remove('modal--show');
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});